<div class="filter-container">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Order Nr</mat-label>
        <input #orderNrF [disabled]="operationInExecution" matInput>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Invoice Nr</mat-label>
        <input #invoiceNrF [disabled]="operationInExecution" matInput>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Vendor</mat-label>
        <input #vendorF [disabled]="operationInExecution" matInput>
    </mat-form-field>

    <button (click)="bulkSendToAccounting.next()" [disabled]="operationInExecution || selection.length === 0" color="primary"
            mat-raised-button>Bulk send to accounting
    </button>
</div>

<mat-tab-group (selectedIndexChange)="selectedTab = $event" [selectedIndex]="selectedTab">

  <mat-tab>
    <ng-template mat-tab-label>
      <span matTooltip="Lista veloce">Invoices list</span>
    </ng-template>

    <app-invoices-list-table [reloadDataSubject]="reloadDataSubject" [selection]="selection"
      [sendBulkToAccounting$]="bulkSendToAccounting.asObservable()"
      searchMode='quick'
    ></app-invoices-list-table>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      @if (performingSlowSearch$ | async) {
        <div class="tab-label-loading">
          <mat-icon matTooltip="Searching...">cloud_sync</mat-icon>
        </div>
      } @else {
        <div class="tab-label-loaded">
          <mat-icon matTooltip="Lista esaustiva ({{slowListElements}} orders)">cloud_done</mat-icon>
          <span>({{ slowListElements }})</span>
        </div>
      }
    </ng-template>

    <app-invoices-list-table (updateTotalElements)="slowListElements = $event"
      [reloadDataSubject]="reloadDataSubject"
      searchMode='slow'
    ></app-invoices-list-table>
  </mat-tab>
</mat-tab-group>


